import api from './api';

const adminService = {
  // Notification admin dashboard (live aggregate over notification-service)
  getNotificationDashboard: () => api.get('/notifications/admin/dashboard'),

  // Feature Flags
  getFeatureFlags: (params) => api.get('/master-data/feature-flags', { params }),
  updateFeatureFlag: (id, data) => api.put(`/master-data/feature-flags/${id}`, data),
  toggleFeatureFlag: (id, data) => api.post(`/master-data/feature-flags/${id}/toggle`, data),
  getFeatureFlagAudit: (flagKey) => api.get(`/master-data/feature-flags/${flagKey}/audit`),

  // Roles
  getRoles: () => api.get('/master-data/roles'),
  createRole: (data) => api.post('/master-data/roles', data),
  updateRole: (id, data) => api.put(`/master-data/roles/${id}`, data),
  deleteRole: (id) => api.delete(`/master-data/roles/${id}`),

  // Tenants
  getTenants: (params) => api.get('/master-data/tenants', { params }),
  getTenant: (id) => api.get(`/master-data/tenants/${id}`),
  createTenant: (data) => api.post('/master-data/tenants', data),
  updateTenant: (id, data) => api.put(`/master-data/tenants/${id}`, data),
  suspendTenant: (id, reason) => api.post(`/master-data/tenants/${id}/suspend`, { reason }),
  reactivateTenant: (id) => api.post(`/master-data/tenants/${id}/reactivate`),
  deleteTenant: (id) => api.delete(`/master-data/tenants/${id}`),
  impersonateTenant: (id, reason) => api.post(`/master-data/tenants/${id}/impersonate`, { reason }),

  // Webhooks
  getWebhooks: () => api.get('/master-data/webhooks'),
  createWebhook: (data) => api.post('/master-data/webhooks', data),
  updateWebhook: (id, data) => api.put(`/master-data/webhooks/${id}`, data),
  deleteWebhook: (id) => api.delete(`/master-data/webhooks/${id}`),
  testWebhook: (id) => api.post(`/master-data/webhooks/${id}/test`),
  getWebhookDeliveries: (id, params) => api.get(`/master-data/webhooks/${id}/deliveries`, { params }),
  retryDelivery: (deliveryId) => api.post(`/master-data/webhook-deliveries/${deliveryId}/retry`),

  // OAuth Apps
  getOAuthApps: () => api.get('/master-data/oauth-apps'),
  createOAuthApp: (data) => api.post('/master-data/oauth-apps', data),
  updateOAuthApp: (id, data) => api.put(`/master-data/oauth-apps/${id}`, data),
  deleteOAuthApp: (id) => api.delete(`/master-data/oauth-apps/${id}`),
};

export default adminService;
